<template>
    <div v-if="loading" class="skeleton" :class="classList" :style="style"></div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';

    interface Props {
        loading?: boolean;
        type?: string;
        color?: string;
        width?: string;
        maxWidth?: string;
        height: string;
        borderRadius?: string;
    }

    const props = withDefaults(defineProps<Props>(), {
        loading: true,
        type: 'rect',
        color: 'light',
        width: '100%',
        maxWidth: 'none',
        borderRadius: '5px',
    });

    const classList = computed(() => [props.type, props.color]);

    const style = computed(() => {
        return {
            borderRadius: props.type === 'circle' ? '50%' : props.borderRadius,
            width: props.width,
            maxWidth: props.maxWidth,
            height: props.height,
        };
    });
</script>

<style lang="scss" scoped>
    @function alpha($light) {
        @return if($light, 0.5, 0.3);
    }

    @mixin loader($light: true) {
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(#fff, alpha($light)), rgba(255, 255, 255, 0));
        transform: translateX(-100%);
        animation: loading 1s infinite;
    }

    .skeleton {
        overflow: hidden;
        z-index: 1;
    }

    .light {
        background-color: var(--joy-color-neutral-20);
        &::after {
            @include loader(true);
        }
    }

    .dark {
        background-color: var(--joy-color-neutral-20);
        &::after {
            @include loader(false);
        }
    }

    /* Safari */
    @-webkit-keyframes loading {
        100% {
            -webkit-transform: translate(100%);
        }
    }

    @keyframes loading {
        100% {
            transform: translateX(100%);
        }
    }
</style>
